import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs'

const HeroSlimline = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="max-w-7xl mx-auto px-6 lg:py-36 py-16">
                    <div className="flex flex-col items-center text-center mx-auto max-w-[840px] gap-4">
                        <CustomBreadcrumbs className="mb-3"/>
                        <Heading size={`${blok.h1_title ? 'h1' : 'h3'}`}>{blok.title}</Heading>
                        <div className="prose max-w-3xl mx-auto leading-6">
                            <RichText>{blok.description}</RichText>
                        </div>
                    </div>
                </div>
            </div>        
        </SbEditable>
    )
}

export default HeroSlimline